import { useCallback, useState } from "react";
import { StripeErrorState, StripeReadyState, StripeState } from "../types";

const useStripeState = () => {
  const [state, setState] = useState<StripeState>({
    phase: "none",
  });

  const resetState = useCallback(() => setState({ phase: "none" }), []);

  const markInitializing = useCallback(() => {
    setState({ phase: "initializing" });
  }, []);

  const markSuccess = useCallback(() => {
    setState({ phase: "success" });
  }, []);

  const markError = useCallback(
    ({
      message,
      retryType,
    }: Pick<StripeErrorState, "message" | "retryType">) => {
      setState({ phase: "error", message, retryType });
    },
    [],
  );

  const markReady = useCallback(
    ({
      stripePromise,
      clientSecret,
    }: Pick<StripeReadyState, "stripePromise" | "clientSecret">) => {
      setState({ phase: "ready", stripePromise, clientSecret });
    },
    [],
  );

  return {
    state,
    resetState,
    markInitializing,
    markSuccess,
    markError,
    markReady,
  };
};

export default useStripeState;
